import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureGitService, getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { CatalogSettingsGitModel, CatalogStoreModel } from './catalog.model';

@Injectable({ providedIn: 'root' })
export class CatalogGitService extends AbstractFeatureGitService<CatalogStoreModel, Y42GitFolders.Catalog> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      gitQuery,
      git,
      errorHandlerService,
      name: 'Catalog-Git',
      basePath: getY42GitPath(Y42GitFolders.Catalog),
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: CatalogSettingsGitModel,
        },
      },
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          childType: 'folder',
          models: {
            linkDataArray: {
              fileName: 'settings.json',
              property: 'linkDataArray',
            },
            nodeDataArray: {
              fileName: 'settings.json',
              property: 'nodeDataArray',
            },
          },
        },
      },
    });
  }
}
